module.exports = __webpack_public_path__ + "res/img_info_t.10a0b57b6a03dbc1b5500b01815a4c10.png";